module.exports = __webpack_public_path__ + "img/logo.3cdf11da.svg";